import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EcryptServiceService } from '../core/auth/EcryptionService/ecrypt-service.service';
import { CrmsettingsService } from './crmsettings.service';
interface TemplateRequest {
  templateName: string;
  languageCode: string;
  templateBody: string;
  templateFooter?: string;
  category: string;
  mediaHeaderType?: string;
  uploadedMediaFileName?: string;
  headerTextBody?: string;
  exampleHeaderFields?: string;
  headerBody?: string;
  exampleBodyFields?: string;
  messageButtons?: MessageButton[];
}

interface MessageButton {
  type: string;
  text?: string;
  phoneNumber?: string;
  url?: string;
  example?: string;
}
@Injectable({
  providedIn: 'root'
})
export class WhatsappTemplateService {
  private apiUrl = environment.serverAPI8 + '/api/templates';
  
  private apiUrl2 = environment.serverAPI8 + '/api/';

  crmSettingsData: any;

  constructor(private http: HttpClient, private crmsettingsService: CrmsettingsService,
    private ecryptService: EcryptServiceService) { }

  createTemplate(templateData: TemplateRequest): Observable<any> {
    const formData = new FormData();
    formData.append('data', JSON.stringify(templateData));

    let accessToken = null;
    let whatsappUrl = null;
    let whatsappBusinessId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      whatsappBusinessId = this.ecryptService.encrypt(this.crmSettingsData.whatsappBusinessId);
    }
    const url = `${this.apiUrl}/create-process`;
    return this.http.post<any>(url, formData);
  }
  createTemplateTwo(templateData: TemplateRequest): Observable<any> {
    const formData = new FormData();
    formData.append('data', JSON.stringify(templateData));

    let accessToken = null;
    let whatsappUrl = null;
    let whatsappBusinessId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
    }

    let params = new HttpParams();

    const url = `${this.apiUrl}/create-process-new`;
    return this.http.post<any>(url, formData, { params });
  }

  getTemplatesList(page: number, size: number, sort): Observable<any> {

    let accessToken = null;
    let whatsappUrl = null;
    let whatsappBusinessId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
    }

    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('act', accessToken)
      .set('wbid', whatsappBusinessId)

    return this.http.get(`${this.apiUrl}`, { params });
  }
  getTemplatesByList(): Observable<any> {
    let params = new HttpParams();
    return this.http.get<any>(`${this.apiUrl}/list`, { params });
  }

  syncTemplates(): Observable<any[]> {

    let accessToken = null;
    let whatsappUrl = null;
    let whatsappBusinessId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      whatsappBusinessId = this.ecryptService.encrypt(this.crmSettingsData.whatsappBusinessId);
    }

    let params = new HttpParams();
    return this.http.post<any[]>(`${this.apiUrl}/sync`, {}, { params });
  }
  syncTemplatesTwo(): Observable<any[]> {

    let accessToken = null;
    let whatsappUrl = null;
    let whatsappBusinessId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      whatsappBusinessId = this.ecryptService.encrypt(this.crmSettingsData.whatsappBusinessId);
    }

    let params = new HttpParams();

    return this.http.post<any[]>(`${this.apiUrl}/sync-new`, {}, { params });
  }
  searchTemplates(searchTerm: string, page: number, size: number, sort?: any): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    if (sort) {
      params = params.set('sort', sort);
    }

    if (searchTerm && searchTerm.trim().length > 0) {
      params = params.set('search', searchTerm.trim());
    }
    return this.http.get(`${this.apiUrl}/search`, { params });
  }
  deleteTemplate(templateId: string): Observable<any> {

    let accessToken = null;
    let whatsappUrl = null;
    let whatsappBusinessId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      whatsappBusinessId = this.ecryptService.encrypt(this.crmSettingsData.whatsappBusinessId);
    }

    let params = new HttpParams();
    if (accessToken) {
      params = params.set('act', accessToken);
    }
    if (whatsappBusinessId) {
      params = params.set('wbid', whatsappBusinessId);
    }

    return this.http.delete(`${this.apiUrl}/delete/${templateId}`, { params });
  }
  getTemplateDataById(templateid: any): Observable<any> {
    return this.http.get(`${this.apiUrl}/${templateid}`);
  }
  updateTemplate(data: any): Observable<any> {

    let accessToken = null;
    let whatsappUrl = null;
    let whatsappBusinessId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
      whatsappBusinessId = this.ecryptService.encrypt(this.crmSettingsData.whatsappBusinessId);
    }

    let params = new HttpParams();

    return this.http.post(`${this.apiUrl}/update-process`, data, { params });
  }
  updateTemplateTwo(data: any): Observable<any> {

    let accessToken = null;
    let whatsappUrl = null;
    let whatsappBusinessId = null;
    const encrypted = localStorage.getItem('crmSettingsData');
    if (encrypted) {
      const decrypted = this.ecryptService.decryptionAES(encrypted);
      this.crmSettingsData = JSON.parse(decrypted);

      accessToken = this.ecryptService.encrypt(this.crmSettingsData.act);
      console.log(accessToken);
    }

    let params = new HttpParams();



    return this.http.post(`${this.apiUrl}/update-process-new`, data, { params });
  }


  isLoading = new Subject<boolean>();

  show() {
    this.isLoading.next(true);
    
  }

  getTemplates(): Observable<any> {
    let params = new HttpParams();
    return this.http.get<any>(`${this.apiUrl2}chatbot/template/list`, { params });
  }

}
